document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-testimonials-track]').forEach(function (track) {
    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;

    track.addEventListener('mousedown', function (e) {
      isDown = true;
      track.classList.add('is-dragging');
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });

    track.addEventListener('mouseleave', function () {
      isDown = false;
      track.classList.remove('is-dragging');
    });

    track.addEventListener('mouseup', function () {
      isDown = false;
      track.classList.remove('is-dragging');
    });

    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      var walk = (x - startX) * 1.2;
      track.scrollLeft = scrollLeft - walk;
    });

    var section = track.closest('.custom-testimonials');
    var prevBtn = section ? section.querySelector('[data-testimonials-prev]') : null;
    var nextBtn = section ? section.querySelector('[data-testimonials-next]') : null;

    function scrollByCard(direction) {
      var card = track.querySelector('.custom-testimonials__card');
      if (!card) return;
      var trackStyles = window.getComputedStyle(track);
      var gap = parseFloat(trackStyles.columnGap || trackStyles.gap || 0);
      var amount = (card.offsetWidth + gap) * direction;
      track.scrollBy({ left: amount, behavior: 'smooth' });
    }

    function updateNavState() {
      if (!prevBtn && !nextBtn) return;
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 2;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= maxScroll - 2;
    }

    track.addEventListener('scroll', updateNavState);
    window.addEventListener('resize', updateNavState);
    updateNavState();

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByCard(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByCard(1);
      });
    }
  });
});